export default function dialogModal({main, on, elm}) {
    const dialog = elm.querySelector('dialog');

    main(() => {
        on('click', '[data-close]', closeBtnHandle);
        on('click', 'dialog', backdropClickHandle);
    });

    const closeBtnHandle = function(e) {
        dialog.close();
    };

    const backdropClickHandle = function(e) {
        const dialogDimensions = dialog.getBoundingClientRect();
        if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
        ) {
            dialog.close()
        }
    };
};

export const model = {};
